import script from "./CharacterDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CharacterDetails.vue?vue&type=script&setup=true&lang=js"

import "./CharacterDetails.vue?vue&type=style&index=0&id=40a0d58c&lang=css"

const __exports__ = script;

export default __exports__